import { Component } from '@angular/core';

@Component({
  selector: 'app-ambassador-hero',
  templateUrl: './ambassador-hero.component.html',
  styleUrls: ['./ambassador-hero.component.scss']
})
export class AmbassadorHeroComponent {

}
